<template>
  <div class="wangeditor" id="wangEditor">
  </div>
</template>

<script>
import E from "wangeditor";
import wLayoutMenu from "@/wLayoutMenu";
import { Promise, reject, resolve } from "q";
export default {
  name: "editoritem",
  data() {
    return {
      editor: null,
      info_: null,
      baseUrl:
        window.location.host.indexOf("bbs.dahe.cn") > -1
          ? "https://bbs-api.dahe.cn"
          : "https://bbs-api.dahe.cn"
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    menus:{
      type: Array,
      default:function(){
        return [
        // "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        // "list", // 列表
        "justify", // 对齐方式
        // "quote", // 引用
        // "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        // "code", // 插入代码
        "undo", // 撤销
        "redo" // 重复
      ]
      }
    },
    height:{
      type: Number,
      default: 800
    }
  },
  watch: {
    value: function(value) {
      if (value !== this.editor.txt.html()) {
        this.editor.txt.html(this.value);
      }
    }
  },
  mounted() {
    this.seteditor();
    this.editor.txt.html(this.content||this.value);
  },
  methods: {
     seteditor() {
      this.editor = new E("#wangEditor");
      this.editor.config.uploadImgShowBase64 = false; // base 64 存储图片
      this.editor.config.uploadFileName = "files"; // 后端接受上传文件的参数名
      this.editor.config.uploadImgMaxSize = 20 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.config.uploadImgMaxLength = 9; // 一次最多上传 9 张图片
      this.editor.config.uploadImgAccept = ["jpg", "jpeg", "png", "gif"];
      this.editor.config.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      this.editor.config.showFullScreen = true;
      this.editor.config.height = this.height;
      this.editor.config.showLinkImg = false;//隐藏插入网络图片功能
      this.editor.menus.extend('shortcutLayout', wLayoutMenu);//一键排版
      // 配置菜单
      this.editor.config.menus = this.menus.concat('shortcutLayout');
      let that = this
      this.editor.config.pasteTextHandle = function (pasteStr) {
        // 数据处理之前
        console.log(pasteStr);

        // 对粘贴的文本进行处理，然后返回处理后的结果
        let imgNum = 0; // 待替换图片个数
        let result; // 最终粘贴到文本框里的内容
        let isreturn = false; // flag,判断图片是否本地化完毕,完毕后再返回
        pasteStr = pasteStr.replace(/<br\/>/gi,"</p><p>").replace(/<br>/gi,"</p><p>");
        // console.log(pasteStr)
        // 需要判断是否是纯文本，不是纯文本执行函数，是纯文本返回
        // 验证文本中是否包含img标签，具有得到true否则得到false
        // var containsImage = pasteStr.search(/<img /i) >= 0;
        // if(containsImage){
        //   console.log(containsImage);
        //   this.disposePasteImg(pasteStr).then((res) => {
        //      editor.txt.append(res);
        //   })
        // }

        
        let imgReg = /<img(?:(?!\/>).|\n)*?\/>/gm;
        let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
        let imgpath_online = [];
        pasteStr.replace(imgReg,(txt)=>{
          // txt是匹配到的img标签
            txt.replace(srcReg,(src)=>{
              var img_src = src.match(srcReg)[1];
              imgpath_online.push(img_src)
            })
        })
        function getlocalpath(img_src){
          return new Promise(async (resolve, reject) => {
            let res = await self.imgUrlSwitchBlob(img_src)
            resolve(res)
          })
        }
        let arr = []
        for (let index = 0; index < imgpath_online.length; index++) {
          const src = imgpath_online[index];
          arr.push(getlocalpath(src))
        }
        Promise.all(arr).then((values) => {
          let text = that.editor.txt.html()
          for (let index = 0; index < values.length; index++) {
            const element = values[index];
            text = text.replace(imgpath_online[index],element)
          }
          that.editor.txt.html(text)
        });
        
        return pasteStr;
      }
      let self = this;
      this.editor.config.customUploadImg = function(files, insertImgFn) {
        var fd = new FormData();
        for (var i = 0; i < files.length; i++) {
          fd.append("files", files[i]);
        }
        // console.log(fd);
        self.$api.uploadImg(fd).then(res => {
          let data = res.data.data;
          for (let i = 0; i < data.length; i++) {
            var imgurl = data[i]
            insertImgFn(imgurl)
          }
        });
      };
      this.editor.config.onchange = html => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
      };
      this.editor.create();
    },
    // 请求接口
    imgUrlSwitchBlob(param) {
      let _this = this;
      param = param + ""
      return new Promise(function (resolve) {
        // console.log(param);
        _this.$api.uploadImgLocal({image:param}).then(res => {resolve(res.data.data[0]);});
      });
    },
    // 异步改变return状态的函数
    changeReturnType(param){
      _this = this;
      return new Promise((resolve,reject)=>{
        if(!param) resolve(!param);
      })
    }
  }
};
</script>

<style lang="css">
.wangeditor {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 0;
}
.editor-toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
  min-height: 800px;
}
.w-e-toolbar .w-e-menu {
  font-size: 14px;
  width: 35px;
  height: 35px;
}
.w-e-full-screen-editor {
  position: fixed;
  width: 100% !important;
  height: 100% !important;
  left: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Editor.vue